var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['the-tabs', _vm.parentPage.color]},[_c('div',{staticClass:"tabs-wrapper"},[(_vm.tabPage)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.tabPage.html)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }